<template>
    <div>
        <v-data-table class="my-5 rounded bordered" v-model:expanded="tabel.laiendatud" :headers="tabel.paised"
            :items="elemendid" :items-per-page="tabel.lehePikkus" :loading="tabel.laeb" fixed-header>
            <template v-slot:[`item.kuupaev`]="{ value }">
                {{ formateeriKuupaev(value) }}
            </template>
            <template v-slot:[`item.nadalapaev`]="{ item }">
                <span class="text-capitalize">{{ formateeriNadalaPaev(item.kuupaev as any) }}</span>
            </template>
            <template v-slot:[`item.algus`]="{ value }">
                {{ formateeriAeg(value) }}
            </template>
            <template v-slot:[`item.lopp`]="{ value }">
                {{ formateeriAeg(value) }}
            </template>
            <template v-slot:[`item.aeg`]="{ item }">
                {{ formateeriAeg(item.algus as any) }} - {{ formateeriAeg(item.lopp as any) }}
            </template>
            <template v-slot:[`item.louna`]="{ value }">
                {{ value }}min
            </template>
            <template v-slot:bottom> </template>
        </v-data-table>
    </div>
</template>
<script lang="ts">
import { AjakavaRidaListItem } from '@/models/UldkasulikToo';
import { PropType, defineComponent } from 'vue';
import mixin from '@/core/mixins';

export default defineComponent({
    name: 'AjakavaTabel',
    mixins: [mixin],
    data() {
        return {
            tabel: {
                laiendatud: [],
                paised: [
                    {
                        title: 'Kuupäev',
                        width: '115px',
                        sortable: false,
                        key: 'kuupaev',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Nädalapäev',
                        width: '120px',
                        sortable: false,
                        key: 'nadalapaev',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap hidden-md-and-down'
                        },
                        cellProps: {
                            class: 'hidden-md-and-down'
                        },
                    },
                    {
                        title: 'Aeg',
                        width: '130',
                        sortable: false,
                        key: 'aeg',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap hidden-lg-and-up'
                        },
                        cellProps: {
                            class: 'hidden-lg-and-up'
                        },
                    },
                    {
                        title: 'Algus',
                        width: '65px',
                        sortable: false,
                        key: 'algus',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap hidden-md-and-down'
                        },
                        cellProps: {
                            class: 'hidden-md-and-down'
                        },
                    },
                    {
                        title: 'Lõpp',
                        width: '65px',
                        sortable: false,
                        key: 'lopp',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap hidden-md-and-down'
                        },
                        cellProps: {
                            class: 'hidden-md-and-down'
                        },
                    },
                    {
                        title: 'Lõuna',
                        width: '65px',
                        sortable: false,
                        key: 'louna',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap'
                        },
                    },
                    {
                        title: 'Tunnid kokku',
                        width: '95px',
                        sortable: false,
                        key: 'tunnid',
                        headerProps: {
                            class: 'v-theme--VokTeema bg-primary text-no-wrap hidden-md-and-down'
                        },
                        cellProps: {
                            class: 'hidden-md-and-down'
                        },
                    },
                ],
                laeb: false,
                lehePikkus: -1
            },
        }
    },
    props: {
        elemendid: Array as PropType<Array<AjakavaRidaListItem>>,
    },
});
</script>

<style scoped>
.bordered {
    border: 1px solid var(--varv-lisa-3);
}
</style>